import React from 'react'
import Button from '../components/Button'
import CustomeIcon from '../components/CustomeIcon'

import { use3DContext } from '../store/threedProvider'

const Zoomout = (props) => {

  const {productStateSelectContext}=use3DContext()
// if(props.productStateSelectContext != undefined){
//   console.log(props.productStateSelectContext,"3Dcontext");
// }

  return (
      <Button data={productStateSelectContext} classList="zoomOutBtn" clickFunction={props.clickFunction}>
        <div
          className="zoomOutImg">
          <p>ZOOM OUT</p>
          <CustomeIcon src="./images/zoomOutIcon.svg"></CustomeIcon>
        </div>

        <p className='zoomDescp'>TO SEE ALL APPLIANCES</p>
      </Button>

  )
}

export default Zoomout;